import { Button, SelectChangeEvent, Snackbar } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";
import { Component } from "react";
import Service from "../../controller/model/service/Service";
import { WithStylesProps } from "../utils/WithStyles";
import { AlertSeverity, EstablishmentPaymentDialogState } from "./_interfaces/obypay";
import EstablishmentPaymentDialog from "../Authentication/EstablishmentPaymentDialog";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";

interface ObyPayConnectedState extends WithStylesProps {
    _logout: () => void
    service: Service
    showAlert: boolean
    _closeSnackBar: () => void
    _setPaymentMapping: () => void
    message: string | undefined
    alertSeverity: AlertSeverity
    showPaymentMappingDialog: boolean
    restaurant: PopinaRestaurant
    _handleSelectValueChange: (selected: SelectChangeEvent<string>, obyPayPaymentMethod: string) => void
    paymentMapping: EstablishmentPaymentDialogState["paymentMapping"]
    _closePaymentMappingDialog: () => void
    _openPaymentMappingDialog: () => void
}

class ObypayConnected extends Component<ObyPayConnectedState> {
    render() {
        const { _logout, service, _closeSnackBar, message, showAlert, alertSeverity, _setPaymentMapping, showPaymentMappingDialog, restaurant, _handleSelectValueChange, paymentMapping, _closePaymentMappingDialog, _openPaymentMappingDialog } = this.props;
        return (
            <div style={this.props.styles.rootStyle}>
            <EstablishmentPaymentDialog isOpen={showPaymentMappingDialog} restaurant={restaurant} _handleSelectValueChange={_handleSelectValueChange} paymentMapping={paymentMapping} _onClickValidate={_setPaymentMapping} _onCloseDialog={_closePaymentMappingDialog} />
            <Snackbar
                open={showAlert}
                autoHideDuration={6000}
                onClose={_closeSnackBar}
            >
                <MuiAlert
                    severity={alertSeverity}
                    onClose={_closeSnackBar}
                >
                  {message}
                </MuiAlert>
            </Snackbar>
                <h2>Connected Establishment: {service.name}</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                    <Button
                        color="primary"
                        variant="contained"
                        style={{ color: "white" }}
                        onClick={_openPaymentMappingDialog}
                    >
                        Set payment mapping
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        style={{ color: "white" }}
                        onClick={_logout}
                    >
                        Déconnexion
                    </Button>
                </div>
            </div>

        )
    }
}

export default ObypayConnected